"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaCampaignGroupEntity = void 0;
class MediaCampaignGroupEntity {
    reqId;
    displayIds;
    campaignIds;
    media;
    campaignOwner;
    displayOwnerIds;
    title;
    statistics;
    dates;
    isSelf;
    isMyCampaign;
    mediaType;
    pricing;
    paymentLink;
    metadata;
    status;
    mediaDuration;
    isExpired;
    updatedAt;
    createdAt;
}
exports.MediaCampaignGroupEntity = MediaCampaignGroupEntity;
